import type { ReactNode } from 'react'
import { Input, Select, type OpsiSelect } from './Input'

export interface NilaiFilter {
  dari: string
  sampai: string
  unitId: string
  fundId: string
  program: string
  kategori: string
}

export const FILTER_KOSONG: NilaiFilter = {
  dari: '',
  sampai: '',
  unitId: '',
  fundId: '',
  program: '',
  kategori: '',
}

export type KunciFilter = keyof NilaiFilter

export function FilterBar({
  nilai,
  onUbah,
  unit = [],
  sumberDana = [],
  program = [],
  kategori = [],
  tampilkan,
  ekstra,
  ringkas = false,
}: {
  nilai: NilaiFilter
  onUbah: (nilai: NilaiFilter) => void
  unit?: OpsiSelect[]
  sumberDana?: OpsiSelect[]
  program?: OpsiSelect[]
  kategori?: OpsiSelect[]
  tampilkan?: Partial<Record<KunciFilter, boolean>>
  ekstra?: ReactNode
  ringkas?: boolean
}) {
  const tampil = (k: KunciFilter): boolean => tampilkan?.[k] !== false

  const ubah = (k: KunciFilter, v: string) => onUbah({ ...nilai, [k]: v })

  const adaIsi = Object.values(nilai).some((v) => v !== '')

  return (
    <div className="mb-4 rounded-xl border border-netral-200 bg-white p-3">
      <div className={`grid grid-cols-1 gap-3 sm:grid-cols-2 ${ringkas ? 'lg:grid-cols-4' : 'lg:grid-cols-3 xl:grid-cols-4'}`}>
        {tampil('dari') ? (
          <Input
            type="date"
            label="Dari tanggal"
            value={nilai.dari}
            onChange={(e) => ubah('dari', e.target.value)}
          />
        ) : null}
        {tampil('sampai') ? (
          <Input
            type="date"
            label="Sampai tanggal"
            value={nilai.sampai}
            onChange={(e) => ubah('sampai', e.target.value)}
          />
        ) : null}
        {tampil('unitId') && unit.length > 0 ? (
          <Select
            label="Unit"
            placeholder="Semua unit"
            opsi={unit}
            value={nilai.unitId}
            onChange={(e) => ubah('unitId', e.target.value)}
          />
        ) : null}
        {tampil('fundId') && sumberDana.length > 0 ? (
          <Select
            label="Sumber Dana"
            placeholder="Semua sumber dana"
            opsi={sumberDana}
            value={nilai.fundId}
            onChange={(e) => ubah('fundId', e.target.value)}
          />
        ) : null}
        {tampil('program') && program.length > 0 ? (
          <Select
            label="Program"
            placeholder="Semua program"
            opsi={program}
            value={nilai.program}
            onChange={(e) => ubah('program', e.target.value)}
          />
        ) : null}
        {tampil('kategori') && kategori.length > 0 ? (
          <Select
            label="Kategori"
            placeholder="Semua kategori"
            opsi={kategori}
            value={nilai.kategori}
            onChange={(e) => ubah('kategori', e.target.value)}
          />
        ) : null}
      </div>
      {(adaIsi || ekstra) && (
        <div className="mt-3 flex flex-wrap items-center gap-2 border-t border-netral-100 pt-3">
          {adaIsi ? (
            <button
              type="button"
              className="text-xs font-medium text-yayasan-800 hover:underline"
              onClick={() => onUbah({ ...FILTER_KOSONG })}
            >
              Bersihkan filter
            </button>
          ) : null}
          {ekstra}
        </div>
      )}
    </div>
  )
}
